
export class DmTaiLieuModel {
    constructor() {
     }
    public id: number;
    public loaiTaiLieu: string;
    public moTa: string;
    public duongDan: string;
    public tenFile: string;
    public ngayCapNhat: Date;
    public nhanVienId: number;
    public invalid: boolean;
    public file: File;
}
